import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { buildFinancialApiUrl } from '../utils/financial-api-url.util';
import { ErrorService } from '../shared/services/error.service';
import {
  ApPositionSummaryQuery,
  ApPositionSummaryResponse
} from '../models/financial-report.models';

/**
 * Relatórios com endpoint dedicado em `/reports/...` (ex.: ap-position-summary).
 * O espelho financeiro usa `FinancialMirrorService` — não passa por aqui.
 */
@Injectable({ providedIn: 'root' })
export class FinancialReportsService {

  private financialUrl(path = ''): string {
    return buildFinancialApiUrl('reports', path);
  }

  constructor(
    private http: HttpClient,
    private errorService: ErrorService
  ) {}

  getApPositionSummary(query: ApPositionSummaryQuery): Observable<ApPositionSummaryResponse> {
    let params = new HttpParams()
      .set('period', query.period)
      .set('format', 'summary');

    if (query.costCenterId != null) {
      params = params.set('costCenterId', String(query.costCenterId));
    }
    if (query.includeChildCostCenters != null) {
      params = params.set('includeChildCostCenters', String(query.includeChildCostCenters));
    }

    const url = this.financialUrl('/accounts-payable/ap-position-summary');
    return this.http.get<ApPositionSummaryResponse>(url, { params }).pipe(
      catchError((err) => {
        this.errorService.handleHttpError(err, 'Erro ao carregar relatório de posição de contas a pagar');
        return throwError(() => err);
      })
    );
  }
}
